import axiosInstance from "../axiosInstance/axiosInstance";
import queryClient from "./queryClient";

// The signed-in guest does not change under us, and the submit paths only read
// `contact` off them.
const CURRENT_USER_STALE_TIME = 5 * 60 * 1000;

// Every request form needs the guest's contact to work out which of the booked
// rooms is theirs before it can post. That used to be a fetch per submission,
// sitting between the guest tapping the button and anything happening.
export const getCurrentUser = async () => {
    const userId = localStorage.getItem("user_id");

    return queryClient.fetchQuery({
        queryKey: ["current-user", userId],
        queryFn: async () => {
            const response = await axiosInstance.get(`/api/v1/users/${userId}`);
            return response.data;
        },
        staleTime: CURRENT_USER_STALE_TIME,
        // Fail as fast as this call used to; the submit paths handle the error.
        retry: false,
    });
};
